import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
});

interface Props{
  placeholder?:string;
  onChange: (value: string)=>void;
  onFocus?: ((event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void) | undefined;
  onBlur?: ((event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void) | undefined;
  value: string;
}

const SearchBar: React.FC<Props> = ({placeholder = "Search ...",onChange,value,onFocus,onBlur}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        inputProps={{ 'aria-label': placeholder}}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>)=>onChange(event.target.value as string)}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <IconButton className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}

export default SearchBar;